module.exports = {"id":"207790","name":"Kaan Ayhan","rating":"73","photo":"./data/images/photos/0/207790.png","club":{"name":"F. Düsseldorf","logo":"./data/images/clubs/F.Dusseldorf.png"},"positions":["DC","MDC","MC"],"photoFolderIndex":0}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/KaanAyhan0.json
// module id = 2271
// module chunks = 0